import AbstractPlatformNotification from "~/operatorApplication/ts/platform/AbstractPlatformNotification";
import AbstractDesktopPlatformNotificationWindow
    from "~/operatorApplication/ts/platform/desktopNotification/AbstractDesktopPlatformNotificationWindow";
import PlatformNotificationParamsInterface from "~/operatorApplication/ts/platform/PlatformNotificationParamsInterface";
import {
    NOTIFICATION_POSITION_BOTTOM_LEFT,
    NOTIFICATION_POSITION_TOP_LEFT,
    NOTIFICATION_POSITION_TOP_RIGHT,
    OperatorApplicationConfigInstance
} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {
    CHANGE_NOTIFICATIONS_CONFIG,
    OperatorApplicationEventManager
} from "~/operatorApplication/ts/OperatorApplicationEventManager";


const HEIGHT = 80;
const MARGIN = 30;
const WIDTH = 360;

export default abstract class AbstractDesktopPlatformNotification extends AbstractPlatformNotification {
    private windows: AbstractDesktopPlatformNotificationWindow[] = [];
    private queue: PlatformNotificationParamsInterface[] = [];

    private displayedWindows: AbstractDesktopPlatformNotificationWindow[] = [];

    private windowsCount = 0;

    private maxWindowsCount = 20;

    constructor() {
        super();
        this.maxWindowsCount = Math.floor((screen.availHeight - MARGIN) / (HEIGHT + MARGIN));
        if (this.maxWindowsCount < 1) {
            this.maxWindowsCount = 1;
        } else if (this.maxWindowsCount > 7) {
            this.maxWindowsCount = 7;
        }

        OperatorApplicationEventManager.addEventListener(CHANGE_NOTIFICATIONS_CONFIG, () => {
            this.reposition();
        });
    }

    public reposition() {
        for (let window of this.displayedWindows) {
            this.setPosition(window);
        }
    }

    private showInProgress = false;

    async show(p: PlatformNotificationParamsInterface): Promise<void> {
        if (!this.showInProgress) {
            this.showInProgress = true;
            let window = await this.getWindowForNotification(p);
            if (window) {
                if (!this.isDisplayed(window)) {
                    this.displayedWindows.push(window);
                    this.setPosition(window);
                }


                (async () => {
                    let result = await window.show(p);
                    if (typeof result == "boolean") {
                        if (result) {
                            if (p.click) {
                                p.click();
                            }
                        } else {
                            if (p.close) {
                                p.close();
                            }
                        }
                        this.closeWindow(window);
                    }
                })();
                this.showInProgress = false;
                this.showNextInQueue();
                return;
            } else {
                this.showInProgress = false;
            }
        }
        let index = p.groupId ? this.queue.findIndex(item => item.groupId === p.groupId) : -1;
        if (index == -1) {
            this.queue.push(p);
        } else {
            this.queue[index] = p;
        }
        return;
    }

    closeByGroupId(groupId: string) {
        for (let i = 0; i < this.queue.length; i++) {
            if (this.queue[i].groupId == groupId) {
                this.queue.splice(i, 1);
                i--;
            }
        }

        for (let window of this.displayedWindows) {
            if (window.groupId == groupId) {
                this.closeWindow(window);
            }
        }
    }

    hasByGroupId(groupId: string): boolean {
        for (let i = 0; i < this.queue.length; i++) {
            if (this.queue[i].groupId == groupId) {
                return true;
            }
        }

        for (let window of this.displayedWindows) {
            if (window.groupId == groupId) {
                return true;
            }
        }
        return false;
    }

    closeAll() {
        this.queue.splice(0, this.queue.length);
        for (let window of this.windows) {
            this.closeWindow(window);
        }
    }

    private isDisplayed(window: AbstractDesktopPlatformNotificationWindow) {
        return this.displayedWindows.indexOf(window) > -1;
    }

    private showNextInQueue() {
        if (this.queue.length) {
            this.show(this.queue.shift());
        }
    }

    private closeWindow(window: AbstractDesktopPlatformNotificationWindow) {
        let index = this.displayedWindows.indexOf(window);
        if (index > -1) {
            this.displayedWindows.splice(index, 1);
            window.close();
            for (let i = index; i < this.displayedWindows.length; i++) {
                this.setPosition(this.displayedWindows[i]);
            }
            this.showNextInQueue();
        }
    }

    private setPosition(window: AbstractDesktopPlatformNotificationWindow) {
        let index = this.displayedWindows.indexOf(window);

        let screenHeight = screen.availHeight;
        let screenWidth = screen.availWidth;
        let position = OperatorApplicationConfigInstance.notificationPosition;
        let isTop = [NOTIFICATION_POSITION_TOP_LEFT, NOTIFICATION_POSITION_TOP_RIGHT].includes(position);
        let isLeft = [NOTIFICATION_POSITION_TOP_LEFT, NOTIFICATION_POSITION_BOTTOM_LEFT].includes(position);

        let x = isLeft ? MARGIN : screenWidth - MARGIN - WIDTH;
        let y = isTop ? -HEIGHT : screenHeight;
        for (let i = 0; i <= index; i++) {
            y -= (MARGIN + HEIGHT) * (isTop ? -1 : 1);
        }
       // let alreadyPositioned = !!(window as any).alreadyPositioned;
        (window as any).alreadyPositioned = true;
        window.setPosition(x, y, false/*alreadyPositioned*/);
        window.setSize(WIDTH, HEIGHT);
    }

    private async getWindowForNotification(p: PlatformNotificationParamsInterface) {
        let result: AbstractDesktopPlatformNotificationWindow;
        if (p.groupId) {
            result = this.windows.find(window => window.groupId == p.groupId);
        }
        if (!result) {
            result = this.windows.find(window => !this.isDisplayed(window));
        }
        if (!result) {
            if (this.windowsCount < this.maxWindowsCount) {
                result = this.createNewWindow();
                this.windowsCount++;
                await result.init();
                this.setPosition(result);
                this.windows.push(result);
                result.setSize(WIDTH, HEIGHT);

            }
        }
        return result;
    }

    protected abstract createNewWindow(): AbstractDesktopPlatformNotificationWindow;
}
